/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".not-accepted[_ngcontent-%COMP%]{color:#000!important;font-weight:700}.mat-column-text[_ngcontent-%COMP%]{word-wrap:break-word!important;white-space:unset!important;flex:0 0 40%!important;width:40%!important;overflow-wrap:break-word;word-wrap:break-word;word-break:break-word;-ms-hyphens:auto;-webkit-hyphens:auto;hyphens:auto}"];
export { styles as styles };
